export function getCurrentEnvironment() {
  // Uncomment localhost in the env you want to test locally.
  // Keep it commented in the other env cases.
  switch (window.location.hostname) {
    case 'www.uat.support.rcshealth.io':
    case 'uat.support.rcshealth.io':
    // case 'localhost':
    // case '127.0.0.1':
      return 'UAT'

    case 'www.dev.support.rcshealth.io':
    case 'dev.support.rcshealth.io':
    case 'localhost':
    case '127.0.0.1':
      return 'DEV'

    case 'www.support.rcshealth.io':
    case 'support.rcshealth.io':
    // case 'localhost':
    // case '127.0.0.1':
      return 'PROD'

    default:
      return 'DEV'
  }
}

export default function GetCurrentCognitoDetailsMethod() {
  switch (getCurrentEnvironment()) {
    case 'UAT':
      return {
        userPoolId: 'us-east-1_2mjrc13a3',
        userPoolClientId: 'j8fk4mv3h9cul2j19mi65cbu2',
        loginWith: {
          email: true
        },
        signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        }
      }

    case 'DEV':
      return {
        userPoolId: 'us-east-1_f2xTSzSCl',
        userPoolClientId: '460jnucop177u13p7lp6q8j1bd',
        loginWith: {
          email: true
        },
        signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:13552369-8ebf-4138-8e46-5b318be12f15'
      }

    case 'PROD':
      return {
        userPoolId: 'us-east-1_P0z4jbq0K',
        userPoolClientId: '14nolh3ursodaerdiiaqr6uq27',
        loginWith: {
          email: true
        },
        signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        }
      }

    default:
      return {
        userPoolId: 'us-east-1_f2xTSzSCl',
        userPoolClientId: '460jnucop177u13p7lp6q8j1bd',
        loginWith: {
          email: true
        },
        signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:13552369-8ebf-4138-8e46-5b318be12f15'
      }
  }
}

const currentCognito = GetCurrentCognitoDetailsMethod()
export const COGNITO_USER_POOL_ID = currentCognito.userPoolId
export const COGNITO_CLIENT_ID = currentCognito.userPoolClientId
export const COGNITO_REGION = 'us-east-1'
